import React, { useState } from 'react';
import { FiShare2 } from 'react-icons/fi';
import './ShareButton.css';

function ShareButton({ product }) {
  const [status, setStatus] = useState('');

  const handleShare = async () => {
    const shareUrl = `${window.location.origin}/product/${product.id}`;
    const shareData = {
      title: product.title,
      text: `Check out ${product.title} on salekiya`,
      url: shareUrl
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        return;
      }

      await navigator.clipboard.writeText(shareUrl);
      setStatus('Copied');
      window.setTimeout(() => setStatus(''), 2000);
    } catch (error) {
      if (error.name !== 'AbortError') {
        setStatus('Unable to share');
        window.setTimeout(() => setStatus(''), 2000);
      }
    }
  };

  return (
    <button
      type="button"
      className="share-btn"
      onClick={handleShare}
      title="Share product"
      aria-label={`Share ${product.title}`}
    >
      <FiShare2 aria-hidden="true" />
      <span>{status || 'Share'}</span>
    </button>
  );
}

export default ShareButton;
